<div class="position-relative w-100 padding">
    <app-main-detail></app-main-detail>
    <app-bnk-partner></app-bnk-partner>
    <app-sub-detail></app-sub-detail>
    <app-bnk-detail></app-bnk-detail>
    <app-bnk-footer></app-bnk-footer>
</div>
